import { Popover } from 'foundations-components/transitional/components/Popover';
import { View } from 'foundations-components/components/View';
import { useSmartPropertyCitationPanelState } from '../../hooks/useSmartPropertyCitationPanelState';
import { SmartPropertyCitationPanel } from '../SmartPropertyCitationPanel/SmartPropertyCitationPanel';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { useCitationPopoverState } from '../../hooks/useCitationPopoverState';
import { Flex } from 'foundations-components/components/Flex';
import CitationPill from 'ai-components-ui-library/components/citation/CitationPill';
import unescapedText from 'I18n/utils/unescapedText';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AsyncPropertyValueCitationPopoverContent = Loadable({
  loader: () => import('./PropertyValueCitationPopoverContent')
});
export function PropertyValueCitationPopover({
  citationType,
  citationId,
  onTrack,
  onOpenSmartPropertyCitationPanel,
  children
}) {
  const {
    panelOpen,
    panelTab,
    handleOpenPanel,
    handleClosePanel
  } = useSmartPropertyCitationPanelState({
    onOpenSmartPropertyCitationPanel,
    onTrack
  });
  const {
    open,
    handleButtonMouseEnter,
    handleButtonMouseLeave,
    handlePopoverMouseEnter,
    handlePopoverMouseLeave,
    handlePopoverClick,
    handleOpenChange
  } = useCitationPopoverState({
    citationType,
    onTrack
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Popover, {
      closeOnOutsideClick: true,
      placement: "bottom",
      content: /*#__PURE__*/_jsx(View, {
        onMouseEnter: handlePopoverMouseEnter,
        onMouseLeave: handlePopoverMouseLeave,
        onClick: handlePopoverClick,
        children: /*#__PURE__*/_jsx(AsyncPropertyValueCitationPopoverContent, {
          citationType: citationType,
          citationId: citationId,
          onTrack: onTrack,
          onOpenPanel: tab => {
            handleOpenPanel(tab, citationId);
            handleOpenChange(syntheticEvent(false));
          }
        })
      }),
      onOpenChange: handleOpenChange,
      open: open,
      inlineSize: "360px",
      maxInlineSize: "min(360px, 100vw - 16px)",
      closeOnTargetLeave: true,
      children: /*#__PURE__*/_jsx(Flex, {
        display: "inline-flex",
        onMouseEnter: handleButtonMouseEnter,
        onMouseLeave: handleButtonMouseLeave,
        children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(CitationPill, {
          label: unescapedText('propertyValueCitationButton.source')
        })
      })
    }), panelOpen && citationType === 'smartPropertyResultId' && /*#__PURE__*/_jsx(SmartPropertyCitationPanel, {
      smartPropertyResultId: citationId,
      onClose: handleClosePanel,
      defaultTab: panelTab
    })]
  });
}